<div class="main-content content-with-side-menu">
    <h1 class="page-header" bcShowIfPrivilegeDynamic="Camps.campsCanManageCoupons">
        {{'Dashboard.title' | translate}}
        <span class="right">
            <app-dashboard-filter [filterForm]="filterForm"></app-dashboard-filter>
        </span>
    </h1>

    <div class="voffset-10">
        <app-statistics-tiles hznTestId="dashboard-statistics-tiles" [filterForm]="filterForm"></app-statistics-tiles>
    </div>

    <div class="row voffset-20">

        <div class="col-12">
            <div class="card">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="card-body h-100">
                            <app-enrollment-info-tile></app-enrollment-info-tile>
                        </div>
                    </div>
                    <div class="col-lg-8 b-l">
                        <div class="card-body h-100">
                            <app-statistics-chart [filterForm]="filterForm"></app-statistics-chart>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="row voffset-20">

        <div class="col-12">
            <div class="card">
                <div class="row">
                    <div class="col-lg-8 b-r">
                        <div class="card-body h-100">
                            <app-daily-amount-chart [filterForm]="filterForm"></app-daily-amount-chart>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card-body h-100">

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
